import { IN_PERSON_TRAINING } from 'constants/actionTypes';

export default (event = {}, action) => {
  switch (action.type) {
    case IN_PERSON_TRAINING.EVENT.DATA_RECEIVE:
    case IN_PERSON_TRAINING.EVENT.UPDATE:
      return action.event;

    default:
      return event;
  }
};
